const FREQUENT = {
    drives: {
        '4x4': "Na 4 koła",
        'back': "Na tylne koła",
        'front': "Na przednie koła",
    },
    gearboxes: {
        auto: 'Automatyczna',
        manual: 'Manualna',
    },
    types: {
        combi: 'Kombi',
        pickup: 'Pickup',
    }
}

// as-is db value is mapped to pl text -> readable by useT (preserve typos)
// mainly from imports, acceptable form ommited
const SPECIFICATION_MAPS = { // TODO: add more if necessary
    'Klimatyzacja': {
        field: 'data.air_conditioning',
        map: {
            "automatic": "Automatyczna",
            "manual": "Manualna",
        }
    },

    'Lemiesz': {
        field: 'akol.lemiesz',
        map: {
            "Szesciopozycyjny": "Sześciopozycyjny",
        },
    },

    'Napęd': {
        field: 'data.drive',
        otherFields: ['akol.naped'],
        map: {
            "4by4": FREQUENT.drives['4x4'],
            "4x4": FREQUENT.drives['4x4'],
            "4x4 (dołączany automatycznie)": FREQUENT.drives['4x4'],
            "4x4 (dołączany ręcznie)": FREQUENT.drives['4x4'],
            "4x4 (stały)": FREQUENT.drives['4x4'],
            "Na obie osie": FREQUENT.drives['4x4'],
            "Na przednią oś": FREQUENT.drives.front,
            "Na pzednie koła": FREQUENT.drives.front,
            "Na tylną oś": FREQUENT.drives.back,
            "back": FREQUENT.drives.back,
            "front": FREQUENT.drives.front,
            "przedni": FREQUENT.drives.front,
            "tylny": FREQUENT.drives.back,

            "gasienice": "Gąsienice",
            "kola": "Koła",
        },
    },

    'Podkategoria pojazdu': {
        field: 'akol.podkategoria_pojazdu',
        map: {
            "chlodnia": "Chłodnia",
            "do przewozu samochodow": "Do przewozu samochodów",
            "do przewozu zwierzat": "Do przewozu zwierząt",
            "do transportu zrebkow drzewnych": "Do transportu zrębków drzewnych",
            "koparko ladowarka": "Koparko ładowarka",
            "rowniarka": "Równiarka",
            "samowyladowcze": "Samowyładowcze",
            "samozaladowcze": "Samozaładowcze",
            "wozidlo": "Wozidło",
            "zageszczarka": "Zagęszczarka",
        },
    },

    'Rodzaj klimatyzacji': {
        field: 'data.automatic_air_conditioning_type',
        map: {
            "dual-zone": "Dwustrefowa",
            "four-zone": "Czterostrefowa",
            "tri-zone": "Trzystrefowa",
        }
    },

    'Rodzaj napędu': {
        field: 'data.drive_4by4_type',
        map: {
            "4by4-automatic": "4x4 Automatyczny",
            "4by4-manual": "4x4 Manualny",
            "4by4-static": "4x4 Statyczny",
        },
    },

    'Skrzynia biegów': {
        field: 'data.gearbox',
        map: {
            "automat": FREQUENT.gearboxes.auto,
            "automatic": FREQUENT.gearboxes.auto,
            "manual": FREQUENT.gearboxes.manual,
        },
    },

    'Typ': {
        field: 'data.body_type',
        otherFields: ['data.truck_body_type'],
        map: {
            "Camper": "Kamper",
            "combi": FREQUENT.types.combi,
            "Combi": FREQUENT.types.combi,
            "Coupé": "Coupe",
            "Furgon (blaszak)": "Furgon",
            "Pick up": FREQUENT.types.pickup,
            "Pick-up": FREQUENT.types.pickup,
        },
    },

    'Wysięgnik': {
        field: 'akol.wysiegnik',
        map: {
            "jednoczesciowy": "Jednoczęściowy",
            "dwuczesciowy": "Dwuczęściowy",
        },
    },
}

export default function mapSpecificationValue (name, value, fieldMap = SPECIFICATION_MAPS) {
    if (!name) return value

    const fieldMapping = fieldMap[name]

    if (!fieldMapping) return value

    return fieldMapping.map[value] || value
}